/**
 * 统一错误处理工具
 * 后端返回格式: {"message":"错误信息","timestamp":"具体时间"}
 * 或 {"detail":"错误信息"}
 * 或 [{"msg":"错误信息"}]
 */

/**
 * 从错误对象中提取错误消息
 * @param {Error|Object} error - 错误对象
 * @param {string} defaultMessage - 默认错误消息
 * @returns {string} 错误消息
 */
export function extractErrorMessage(error, defaultMessage = '未知错误') {
  // 如果 error.response 存在（axios 错误）
  if (error.response && error.response.data) {
    const data = error.response.data

    // 优先尝试 message 字段（新格式）
    if (data.message) {
      return data.message
    }

    // 尝试 detail 字段（旧格式）
    if (data.detail) {
      const detail = data.detail
      if (typeof detail === 'string') {
        return detail
      } else if (Array.isArray(detail)) {
        return detail[0]?.msg || detail[0] || JSON.stringify(detail)
      } else if (typeof detail === 'object') {
        return JSON.stringify(detail)
      }
    }
  }

  // 如果是网络错误或其他错误
  if (error.message) {
    return error.message
  }

  // 兜底
  return defaultMessage
}